module.exports = __webpack_public_path__ + "@/assets/img/scholarships-icon.e95e630b.svg";